var render, staticRenderFns
import script from "./TournamentSelectContainer.vue?vue&type=script&lang=tsx"
export * from "./TournamentSelectContainer.vue?vue&type=script&lang=tsx"
import style0 from "./TournamentSelectContainer.vue?vue&type=style&index=0&id=2d269522&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d269522",
  null
  
)

export default component.exports